import _regeneratorRuntime from "C:/Users/Flavio.mendes/persDev/flavio-blog/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _slicedToArray from "C:/Users/Flavio.mendes/persDev/flavio-blog/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:/Users/Flavio.mendes/persDev/flavio-blog/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import getYear from 'date-fns/getYear';
import addDays from 'date-fns/addDays';
import getDay from 'date-fns/getDay';
import getMonth from 'date-fns/getMonth';
import isAfter from 'date-fns/isAfter';
import isSameYear from 'date-fns/isSameYear';
import setDay from 'date-fns/setDay';
import subYears from 'date-fns/subYears';
import color from 'tinycolor2';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles_chart__316M8 {\n  margin-bottom: 1rem;\n}\n\n.styles_calendar__1PAia {\n  max-width: 100%;\n  height: auto;\n  margin-bottom: 0.25rem;\n  overflow: visible;\n}\n\n.styles_loading__1gKsy {\n  font-size: 90%;\n}\n\n.styles_title__HcRKb {\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.25rem;\n}\n";
var styles = {
  "chart": "styles_chart__316M8",
  "calendar": "styles_calendar__1PAia",
  "loading": "styles_loading__1gKsy",
  "title": "styles_title__HcRKb"
};
styleInject(css_248z); // GitHub theme

var DEFAULT_THEME = {
  background: 'transparent',
  text: '#000',
  grade4: '#216e39',
  grade3: '#30a14e',
  grade2: '#40c463',
  grade1: '#9be9a8',
  grade0: '#ebedf0'
};
var NAMESPACE = 'react-github-calendar';
var LINE_HEIGHT = 1.5;
var MIN_DISTANCE_MONTH_LABELS = 2;

function usePrevious(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
} // Import modules separately to reduce bundle size


var API_URL = 'https://github-calendar.now.sh/v1/';
var DATE_FORMAT = 'yyyy-MM-dd';

function getContributionsForDate(data, date) {
  return data.contributions.find(function (contrib) {
    return contrib.date === date;
  });
}

function getContributionCountForLastYear(data) {
  var contributions = data.contributions;
  var now = new Date(); // Start date for accumulating the values

  var begin = contributions.findIndex(function (contrib) {
    return contrib.date === format(now, DATE_FORMAT);
  }); // No data for today given

  if (begin === -1) {
    return 0;
  } // Check if there is data for the day one year past


  var end = contributions.findIndex(function (contrib) {
    return contrib.date === format(subYears(now, 1), DATE_FORMAT);
  }); // Take the oldest contribution otherwise, if not enough data exists

  if (end === -1) {
    end = contributions.length - 1;
  }

  return contributions.slice(begin, end).reduce(function (acc, contrib) {
    return acc + contrib.count;
  }, 0);
}

function getContributionCountForYear(data, year) {
  var yearEntry = data.years.find(function (entry) {
    return entry.year === String(year);
  });
  return yearEntry ? yearEntry.total : 0;
}

function getBlocksForYear(year, data, fullYear) {
  var now = new Date();
  var firstDate = fullYear ? subYears(now, 1) : parseISO("".concat(year, "-01-01"));
  var lastDate = fullYear ? now : parseISO("".concat(year, "-12-31"));
  var weekStart = firstDate; // The week starts on Sunday - add days to get to next sunday if neccessary

  if (getDay(firstDate) !== 0) {
    weekStart = addDays(firstDate, getDay(firstDate));
  } // Fetch graph data for first row (Sundays)


  var firstRowDates = [];

  while (weekStart <= lastDate) {
    var date = format(weekStart, DATE_FORMAT);
    firstRowDates.push({
      date: date,
      info: getContributionsForDate(data, date)
    });
    weekStart = setDay(weekStart, 7);
  } // Add the remainig days per week (column for column)


  return firstRowDates.map(function (dateObj) {
    var dates = [];

    for (var i = 0; i <= 6; i += 1) {
      var _date = format(setDay(parseISO(dateObj.date), i), DATE_FORMAT);

      if (isAfter(parseISO(_date), lastDate)) {
        break;
      }

      dates.push({
        date: _date,
        info: getContributionsForDate(data, _date)
      });
    }

    return dates;
  });
}

function getMonthLabels(blocks, fullYear) {
  var weeks = blocks.slice(0, fullYear ? blocks.length - 1 : blocks.length);
  var previousMonth = 0; // January

  return weeks.reduce(function (labels, week, x) {
    var firstWeekDay = parseISO(week[0].date);
    var month = getMonth(firstWeekDay) + 1;
    var monthChanged = month !== previousMonth;
    var firstMonthIsDecember = x === 0 && month === 12;

    if (monthChanged && !firstMonthIsDecember) {
      labels.push({
        x: x,
        label: format(firstWeekDay, 'MMM')
      });
      previousMonth = month;
    }

    return labels;
  }, []);
}

function getGraphDataForYear(year, data, fullYear) {
  var blocks = getBlocksForYear(year, data, fullYear);
  var monthLabels = getMonthLabels(blocks, fullYear);
  var totalCount = fullYear ? getContributionCountForLastYear(data) : getContributionCountForYear(data, year);
  return {
    year: year,
    blocks: blocks,
    monthLabels: monthLabels,
    totalCount: totalCount
  };
}

function getGitHubGraphData(_x) {
  return _getGitHubGraphData.apply(this, arguments);
}

function _getGitHubGraphData() {
  _getGitHubGraphData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var fullYear, username, years, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fullYear = options.fullYear, username = options.username, years = options.years;
            _context.next = 3;
            return fetch(API_URL + username);

          case 3:
            _context.next = 5;
            return _context.sent.json();

          case 5:
            data = _context.sent;

            if (data.years.length) {
              _context.next = 8;
              break;
            }

            throw Error('No data available');

          case 8:
            return _context.abrupt("return", years.map(function (year) {
              var isCurrentYear = isSameYear(parseISO(String(year)), new Date());
              return getGraphDataForYear(year, data, isCurrentYear && fullYear);
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGitHubGraphData.apply(this, arguments);
}

function createCalendarTheme(baseColor) {
  var textColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'inherit';
  var emptyCellColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : color('white').darken(8).toHslString();
  var background = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'transparent';
  var base = color(baseColor);

  if (!base.isValid()) {
    return DEFAULT_THEME;
  }

  var text = color(textColor).isValid() ? String(color(textColor)) : DEFAULT_THEME.text;
  return {
    background: background,
    text: text,
    grade4: base.setAlpha(0.92).toHslString(),
    grade3: base.setAlpha(0.76).toHslString(),
    grade2: base.setAlpha(0.6).toHslString(),
    grade1: base.setAlpha(0.44).toHslString(),
    grade0: emptyCellColor
  };
}

function getClassName(name, extra) {
  if (extra) {
    return "".concat(NAMESPACE, "__").concat(name, " ").concat(extra);
  }

  return "".concat(NAMESPACE, "__").concat(name);
}

var GitHubCalendar = function GitHubCalendar(_ref) {
  var username = _ref.username,
      _ref$blockMargin = _ref.blockMargin,
      blockMargin = _ref$blockMargin === void 0 ? 2 : _ref$blockMargin,
      _ref$blockSize = _ref.blockSize,
      blockSize = _ref$blockSize === void 0 ? 12 : _ref$blockSize,
      children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? undefined : _ref$color,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'MMM d, yyyy' : _ref$dateFormat,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fullYear = _ref.fullYear,
      fullYear = _ref$fullYear === void 0 ? true : _ref$fullYear,
      _ref$showTotalCount = _ref.showTotalCount,
      showTotalCount = _ref$showTotalCount === void 0 ? true : _ref$showTotalCount,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? undefined : _ref$theme,
      _ref$years = _ref.years,
      years = _ref$years === void 0 ? [Number(format(new Date(), 'yyyy'))] : _ref$years;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      graphs = _useState2[0],
      setGraphs = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var prevYears = usePrevious(years);
  var prevUsername = usePrevious(username);
  var prevFullYear = usePrevious(fullYear);
  var fetchData = useCallback(function () {
    setError(null);
    getGitHubGraphData({
      years: years,
      username: username,
      fullYear: fullYear
    }).then(setGraphs).catch(setError);
  }, [years, username, fullYear]); // Fetch data on mount

  useEffect(function () {
    fetchData();
  }, []); // eslint-disable-line
  // Refetch if relevant props change

  useEffect(function () {
    if (prevFullYear !== fullYear || prevUsername !== username || prevYears.some(function (y) {
      return !years.includes(y);
    })) {
      fetchData();
    }
  }, [fetchData, fullYear, prevFullYear, prevUsername, prevYears, username, years]);

  function getTheme() {
    if (theme) {
      return Object.assign({}, DEFAULT_THEME, theme);
    }

    if (color) {
      return createCalendarTheme(color);
    }

    return DEFAULT_THEME;
  }

  function getDimensions() {
    var textHeight = Math.round(fontSize * LINE_HEIGHT); // Since weeks start on Sunday, there is a good chance that the graph starts
    // in the week before January 1st. Therefore, the calendar shows 53 weeks.

    var width = (52 + 1) * (blockSize + blockMargin) - blockMargin;
    var height = textHeight + (blockSize + blockMargin) * 7 - blockMargin;
    return {
      width: width,
      height: height
    };
  }

  function getTooltipMessage(day) {
    var date = parseISO(day.date);
    return "<strong>".concat(day.info.count, " contributions</strong> on ").concat(format(date, dateFormat));
  }

  function renderMonthLabels(monthLabels) {
    var style = {
      fill: getTheme().text,
      fontSize: fontSize
    }; // Remove the first month label if there's not enough space to the next one
    // (end of previous month)

    if (monthLabels[1].x - monthLabels[0].x <= MIN_DISTANCE_MONTH_LABELS) {
      monthLabels.shift();
    }

    return monthLabels.map(function (month) {
      return /*#__PURE__*/React.createElement("text", {
        x: (blockSize + blockMargin) * month.x,
        y: fontSize,
        key: month.x,
        style: style
      }, month.label);
    });
  }

  function renderBlocks(blocks) {
    var theme = getTheme();
    var textHeight = Math.round(fontSize * LINE_HEIGHT);
    return blocks.map(function (week) {
      return week.map(function (day, y) {
        return /*#__PURE__*/React.createElement("rect", {
          x: "0",
          y: textHeight + (blockSize + blockMargin) * y,
          width: blockSize,
          height: blockSize,
          fill: theme["grade".concat(day.info ? day.info.intensity : 0)],
          "data-tip": day.info ? getTooltipMessage(day) : null,
          key: day.date
        });
      });
    }).map(function (week, x) {
      return /*#__PURE__*/React.createElement("g", {
        key: x,
        transform: "translate(".concat((blockSize + blockMargin) * x, ", 0)")
      }, week);
    });
  }

  function renderTotalCount(year, totalCount) {
    var isCurrentYear = getYear(new Date()) === year;
    return /*#__PURE__*/React.createElement("div", {
      className: getClassName('meta'),
      style: {
        fontSize: fontSize
      }
    }, isCurrentYear && fullYear ? 'Last year' : year, ' – ', isCurrentYear && !fullYear ? 'So far ' : null, totalCount, " contributions");
  }

  var _getDimensions = getDimensions(),
      width = _getDimensions.width,
      height = _getDimensions.height;

  if (error) {
    console.error(error);
    return /*#__PURE__*/React.createElement("p", null, "Error :(");
  }

  if (!graphs) {
    return /*#__PURE__*/React.createElement("div", {
      className: getClassName('loading', styles.loading)
    }, "Loading \u2026");
  }

  return /*#__PURE__*/React.createElement("article", {
    className: NAMESPACE,
    style: style
  }, graphs.map(function (graph) {
    var year = graph.year,
        blocks = graph.blocks,
        monthLabels = graph.monthLabels,
        totalCount = graph.totalCount;
    return /*#__PURE__*/React.createElement("div", {
      key: year,
      className: getClassName('chart', styles.chart)
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: "0 0 ".concat(width, " ").concat(height),
      className: getClassName('calendar', styles.calendar),
      style: {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.background
      }
    }, renderMonthLabels(monthLabels), renderBlocks(blocks)), showTotalCount && renderTotalCount(year, totalCount), children);
  }));
};

export default GitHubCalendar;
export { createCalendarTheme };